/**
 * Resolves the "section" id used in video deep links.
 * Prefer a block’s `data-section-id` (stable hub section) over any nearer `[id]`,
 * so we don’t accidentally bind to an inner Craft wrapper id.
 */
export function resolveSectionIdFromElement(
  element: HTMLElement | null | undefined
): string | null {
  if (!element) return null;

  const withSectionAttr = element.closest(
    "[data-section-id]"
  ) as HTMLElement | null;
  if (withSectionAttr) {
    return withSectionAttr.getAttribute("data-section-id") || null;
  }

  const withId = element.closest("[id]") as HTMLElement | null;
  if (withId) {
    return withId.getAttribute("id") || null;
  }

  return null;
}
